/**
 * 申請受付カスタム　定数記録用ファイル
 */
import { Constants } from '@/CommonUtils/fixed/Constants';

// tslint:disable-next-line:no-namespace
export namespace CustomConstants {

  export const CE_FOUNDATION_PATH = Constants.UKETSUKE_URL + '/ceFoundation';

  export const TRADER_INFO_PATH = CE_FOUNDATION_PATH + '/traderInfo';

  export const TRADER_INFO_INIT_PATH = TRADER_INFO_PATH + Constants.PATH_TAIL_INIT;

  export const TRADER_INFO_SEARCH_PATH = TRADER_INFO_PATH + '/search';

  export const TRADER_INFO_SEARCH_INIT_PATH = TRADER_INFO_SEARCH_PATH + Constants.PATH_TAIL_INIT;

  export const TRADER_INFO_WORKTYPES_PATH = TRADER_INFO_PATH + '/workTypes';

  export const TRADER_INFO_WORKTYPES_INIT_PATH = TRADER_INFO_WORKTYPES_PATH + Constants.PATH_TAIL_INIT;

  export const TRADER_INFO_WORKTYPES_UPDATE_PATH = TRADER_INFO_WORKTYPES_PATH + Constants.PATH_TAIL_UPDATE;

  export const TRADER_INFO_KANRI_PATH = TRADER_INFO_PATH + '/kanri';

  export const TRADER_INFO_KANRI_DELETE_PATH = TRADER_INFO_PATH + '/kanri/delete';

  export const TRADER_INFO_KANRI_INIT_PATH = TRADER_INFO_KANRI_PATH + Constants.PATH_TAIL_INIT;

  export const TRADER_INFO_KANRI_INIT_SEARCH_PATH = TRADER_INFO_KANRI_INIT_PATH + '/search';
  //定期申請
  export const PERIODIC = '2';
  //中間申請
  export const INTERMEDIATE = '3';
  //中間申請2
  export const INTERMEDIATE2 = '5';
}
